import { getLanguage, getLanguageCode } from '@/utils'

/**
 *
 * @param date
 * @param lang
 * @param options
 * @return {string|*}
 */
export function formatDate(date, lang, options = { year: 'numeric', month: 'short', day: 'numeric' }) {
  const defaultLang = getLanguage()
  lang = lang || defaultLang
  if (!date || !window.Intl) {
    return date
  }

  if (!(date instanceof Date)) {
    let orig = date
    const timestamp = Date.parse(orig)

    if (isNaN(timestamp) == false) {
      date = new Date(timestamp)
    }

    if (!date || !(date instanceof Date)) {
      return orig
    }
  }
  return new Intl.DateTimeFormat(lang, options).format(date)
}

/**
 *
 * @param time
 * @return {string|*}
 */
export function formatDateTime(time) {
  return formatDate(time, undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  })
}

/**
 *
 * @return {{pretty: string, mask: string}}
 */
export function getDateFormat() {
  const defaultLangCode = getLanguageCode()
  switch (defaultLangCode) {
    case 'hu':
      return {
        pretty: 'yyyy-MM-dd',
        mask: '####-##-##',
      }
    default:
      return {
        pretty: 'mm/dd/yyyy',
        mask: '##/##/####',
      }
  }
}

/**
 *
 * @return {{pretty: string, mask: string}}
 */
export function getTimeFormat() {
  const defaultLangCode = getLanguageCode()
  switch (defaultLangCode) {
    default:
      return {
        pretty: 'HH:mm',
        mask: '##:##',
      }
  }
}
